<template>
  <router-view v-slot="{ Component }">
  <transition name="fade" mode="out-in">
    <component :is="Component"/>
  </transition>
  </router-view>
<!-- <router-view/> -->
</template>

<style lang="scss">
#app {
  font-family: 'Roboto', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #fff;
  font-weight: bold;
  background: #011D1C;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
